window.initFilters = function (selector, url, useLocalstorage = false) {
  let typingTimer;
  let inputs = document.querySelectorAll(selector);
  getValues();

  inputs.forEach(input => {
    if (input.type === "search") {
      input.addEventListener("keyup", () => {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(submitFilters, 300);
      });
    } else {
      if (!input.classList.contains('js-dont-trigger-filter')) {
        input.addEventListener("change", submitFilters);
      }
    }
  });

  function submitFilters(onLoad = false) {
    let params = new URLSearchParams();

    inputs.forEach(input => {
      if (input.type === "radio") {
        if (input.checked) {
          params.append(input.name, input.value);
        }
      } else if (input.type === "checkbox") {
        if (input.checked) {
          params.append(input.name, input.value);
        }
      } else if (input.value) {
        params.append(input.name, input.value);
      }
    });

    $.ajax({
      method: "GET",
      url: `${url}?${params}`,
      dataType: "script",
      beforeSend: console.log('send!'),
      complete: setValues
    });
  }

  function setValues() {
    if (useLocalstorage) {
      const formData = Array.from(inputs).filter(item => item.value).map(item => ({
        id: item.id,
        value: item.value
      }));
      localStorage.setItem(url, JSON.stringify(formData));
    }
  }

  function getValues() {
    if (useLocalstorage) {
      const localStorageData = JSON.parse(localStorage.getItem(url));
      if (localStorageData) {
        inputs.forEach(input => {
          const match = localStorageData.find(item => item.id === input.id)
          if (match) input.value = match.value;
        })
        submitFilters();
      }
    }
  }
}
